import script from "./IpResultsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./IpResultsTable.vue?vue&type=script&setup=true&lang=js"

import "./IpResultsTable.vue?vue&type=style&index=0&id=036edfb5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-036edfb5"]])

export default __exports__